import { useTreatment } from '@splitsoftware/splitio-react';
import { useEffect } from 'react';
import useFeatureFlagsStore from '@/store/FeatureFlagsStore';
import { blastDataToLogCannon } from '@/utils/blastDataToLogCannon';

export type FeatureFlags = {
  useNewDestinations: boolean;
};

const useFeatureFlags = (): FeatureFlags => {
  const setFeatureFlags = useFeatureFlagsStore(
    (state) => state.setFeatureFlags,
  );
  const setFeatureFlagsReady = useFeatureFlagsStore(
    (state) => state.setFeatureFlagsReady,
  );
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  const { treatment: useNewDestinationsTreatment, isReady, hasTimedout } = useTreatment({
    name: 'use-new-sf-destination',
  });

  useEffect(() => {
    if (hasTimedout) {
      blastDataToLogCannon({
        message: 'Split SDK timed out before ready — useNewDestinations defaulting to false',
        level: 'error',
        app: 'travel-scheduler',
      });
      setFeatureFlags({ useNewDestinations: false });
      setFeatureFlagsReady(true);
      return;
    }
    if (!isReady) return;
    setFeatureFlags({
      useNewDestinations: useNewDestinationsTreatment === 'on',
    });
    setFeatureFlagsReady(true);
  }, [isReady, hasTimedout, useNewDestinationsTreatment, setFeatureFlags, setFeatureFlagsReady]);

  return featureFlags;
};

export default useFeatureFlags;
